import { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Switch
} from '@nextui-org/react';
import { Coupon, createCoupons } from 'common/src/api/coupons';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export function CreateCouponModal({ isOpen, onClose, onSuccess }: Props) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    code: '',
    discount_amount: '',
    is_percentage: false,
    max_uses: '',
    expires_at: '',
    is_active: true
  } as Coupon);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { error } = await createCoupons(formData)
      if (error) throw error;

      onSuccess();
      onClose();
      setFormData({
        code: '',
        discount_amount: '',
        is_percentage: false,
        max_uses: '',
        expires_at: '',
        is_active: true
      });
    } catch (error) {
      console.error('Error creating coupon:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <form onSubmit={handleSubmit}>
          <ModalHeader>Crear Cupón</ModalHeader>
          <ModalBody className="space-y-4">
            <Input
              label="Código"
              value={formData.code}
              onChange={(e) => setFormData(prev => ({...prev, code: e.target.value}))}
              placeholder="Ej: VERANO2024"
              required
            />

            <Input
              label={formData.is_percentage ? "Porcentaje de descuento" : "Monto de descuento"}
              value={formData.discount_amount}
              onChange={(e) => setFormData(prev => ({...prev, discount_amount: e.target.value}))}
              type="number"
              required
            />

            <Switch
              isSelected={formData.is_percentage}
              onValueChange={(value) => setFormData(prev => ({...prev, is_percentage: value}))}
            >
              ¿Es porcentaje?
            </Switch>

            <Input
              label="Usos máximos"
              value={formData.max_uses}
              onChange={(e) => setFormData(prev => ({...prev, max_uses: e.target.value}))}
              type="number"
            />

            <Input
              label="Fecha de expiración"
              value={formData.expires_at}
              onChange={(e) => setFormData(prev => ({...prev, expires_at: e.target.value}))}
              type="datetime-local"
            />
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={onClose}>
              Cancelar
            </Button>
            <Button color="primary" type="submit" isLoading={loading}>
              Crear
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
} 